import { ZodFirstPartySchemaTypes } from 'zod';
import IValidationResult from '../../interfaces/IValidationResult';

const validate = (validationSchema: ZodFirstPartySchemaTypes, object: any) => {
    const result = validationSchema.safeParse(object);

    const validationResult = {
        success: result.success,
    } as IValidationResult;

    if (!result.success) {
        validationResult.errors = result.error.format();
    }

    return validationResult;
};

const getError = (
    fieldErrors: { _errors: string[] } | undefined,
    t: (key: string) => string,
) => t(fieldErrors?._errors[0] ?? '');

export default (() => {
    return {
        validate,
        getError,
    };
})();
